<template>
        <!-- swiper -->
        <div class="banner">

            <swiper ref="mySwiper" :options="swiperOptions" class="swiper">
                <swiper-slide v-for="item in picList" :key="item.id">
                    <img :src="item.url" alt="">
                </swiper-slide>
                <div class="swiper-state" id="parent" slot="pagination"></div>
            </swiper>

            <div class="target">
                <div class="wrap d_f d_f_c jc_c ai_c">
                    <h2 :class="flag ? 'M_x' : 'P_xxxl'" class="c_white">专业智能交通设备实力品牌</h2>
                    <router-link to="/about" class="c_white target-about">进一步，了解更多</router-link>
                </div>
            </div>

            <!-- <div class="cp" v-if="flag">
                <button class="M_x" @click="scanning"><img src="../../assets/sm.png" alt=""> 产品追溯</button>
            </div> -->

        </div>
        <!-- swiper-end -->
</template>


<script>

import {mapState} from 'vuex'
import headerSwiper from '../../api/headerSwiper'
export default {
    data() {
      return {
        swiperOptions: {
          loop : true ,
          pagination: {
            el: '.swiper-state'
          },
          autoplay:{
            delay: 5000,
            enabled: true
          }
        },
        picList : []
      }
    },
    created(){
        headerSwiper.selectByState({
            corpId : '1260178594865426434'
        }).then(res=>{
            this.picList = res.picList
        })
    },
    computed:mapState({
        flag : state => state.flag
    }),
    methods : {
        scanning(){
            this.$router.push({path:'/data'});
        }
    }
}
</script>

<style lang="scss" scoped>

    .banner{
        position: relative;
        height: 600px;
    }
    .swiper{
        height: 100%;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .swiper-state{
        position: absolute;
        bottom: 50px !important;
        height: 17px;
        text-align: center;
        z-index: 5;
    }
    // #parent /deep/ .swiper-pagination-bullet{
    //     width: 17px !important;
    //     height: 17px !important;
    //     background-color: #fff;
    //     border-radius: 0;
    //     margin: 0 10px !important;
    // }

    .target{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 20;
        background: rgba(0,103,204,0.45);
        .wrap{
            width: 1200px;
            height: 100%;
            margin: auto;
            .target-about{
                width: 185px;
                height: 54px;
                line-height: 54px;
                border: 1px solid #fff;
                text-align: center;
                &:hover{
                    color: #0067CC;
                    border: 1px solid #0067CC;
                }
            }
        }
    }

     @media screen and (min-width: 1900px) {
         .swiper{
             img{
                 width: 100%;
             }
         }
     }

    @media screen and (max-width: 750px) {
        .banner{
            height: 49.202vw;
        }
        .target {
            .wrap{
                width: 100%;
                .target-about{
                    height: 7.979vw;
                    width: 37vw;
                    font-size: 3.191vw;
                    line-height: 7.979vw;
                    font-family: "PingFangSC-Light";
                }
                h2{
                    margin:5.33vw 0;
                }
            }
        }
        .swiper-state{
            bottom: 8.298vw !important;
        }
    //     #parent /deep/ .swiper-pagination-bullet{
    //     width: 1.596vw !important;
    //     height: 1.596vw !important;
    // }
    }

    .cp{
        position: absolute;
        z-index: 100;
        bottom: -7.447vw;
        left: 50%;
        transform: translateX(-50%);
        width: 58.511vw;
        height: 14.894vw;
        background-color: #fff;
        border-radius: 2.66vw;
        button{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 53.191vw;
            height: 10.638vw;
            margin: 2.128vw 2.66vw;
            border-radius: 2.66vw;
            background-color: #007ee3;
            color: #fff;
            img{
                margin-right:1.33vw;
            }
        }
    }

</style>